import { css } from 'styled-components'

export const revealZoom = css`
  img {
    transform: scale(1.12);
    transition: transform 2s ease;
  }

  &.animate img {
    transform: scale(1);
  }

  @media (prefers-reduced-motion: reduce) {
    img,
    &.animate img {
      transform: none;
      transition: none;
    }
  }
`
